import { render, staticRenderFns } from "./TeacherNavigationDrawer.vue?vue&type=template&id=33cc35dd"
import script from "./TeacherNavigationDrawer.vue?vue&type=script&lang=js"
export * from "./TeacherNavigationDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports